import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * Tabs the page can open directly.
 *
 * Without a URL-addressable tab the notifications hub could only link to
 * "Alerts" and leave the reader to find the Rules tab themselves — which is
 * the same "where do I actually change this" problem the hub exists to end.
 */
export const ALERTS_TABS = ['events', 'rules', 'presets', 'incidents'] as const;

export type AlertsTab = (typeof ALERTS_TABS)[number];

const VALID_TABS: ReadonlySet<string> = new Set(ALERTS_TABS);

export interface AlertsSearch {
  tab?: AlertsTab;
  /**
   * Deep link to one event, used by the owner/admin dashboards. It predates
   * `tab` and must survive validation: an unlisted key is dropped, which would
   * turn "open this alert" into "open the alerts page".
   */
  alertId?: string;
}

export const Route = createFileRoute('/alerts')({
  component: lazyRouteComponent(() => import('./-alerts.lazy'), 'default'),
  validateSearch: (search: Record<string, unknown>): AlertsSearch => ({
    ...(typeof search.tab === 'string' && VALID_TABS.has(search.tab)
      ? { tab: search.tab as AlertsTab }
      : {}),
    ...(typeof search.alertId === 'string' && search.alertId
      ? { alertId: search.alertId }
      : {}),
  }),
});
